export default __webpack_public_path__ + "static/media/sola.3ee12397.png";